module.exports = __webpack_public_path__ + "img/verif.add5fa6f.png";